import React, { Component } from 'react';
// import PropTypes from "prop-types";

import { NavLink } from 'react-router-dom';

import { Query } from 'react-apollo';
import { PEOPLE_QUERY } from '../graphql';

import { personToPath } from '../utils';
import distanceInWords from 'date-fns/distance_in_words';

import InfiniteScroll from 'react-infinite-scroller';

import uniqueBy from 'lodash.uniqby';

const PersonListItem = ({ person }) => {
  return (
    <NavLink
      to={personToPath(person)}
      activeClassName="active"
      className="list-group-item list-group-item-action flex-column align-items-start"
    >
      <div className="d-flex w-100 justify-content-between">
        <h5 className="mb-1">{person.name}</h5>
        <small>{distanceInWords(new Date(), person.updated_at)} ago</small>
      </div>
      {/* <p className="mb-1">
        Donec id elit non mi porta gravida at eget metus. Maecenas sed diam eget
        risus varius blandit.
      </p> */}
      {/* <small>Donec id elit non mi porta.</small> */}
    </NavLink>
  );
};

const PeopleList = ({ people }) => {
  return (
    <div className="list-group" style={{ paddingTop: 10 }}>
      {(people || []).map(person => (
        <PersonListItem person={person} key={person.id} />
      ))}
    </div>
  );
};

export class PeoplePage extends Component {
  state = {
    query: '',
  };

  render() {
    const { error, loading, people, loadMore, query } = this.props;
    if (loading) return <div className="loading">Loading...</div>;

    return (
      <InfiniteScroll
        loadMore={loadMore}
        pageStart={0}
        hasMore={true || false}
        useWindow={false}
        threshold={250}
        loader={
          <div className="loader" key={0}>
            Loading ...
          </div>
        }
      >
        <div style={{ paddingTop: 0 }}>
          <PeopleList people={people} />
        </div>
      </InfiniteScroll>
    );
  }
}

// https://reactjs.org/docs/typechecking-with-proptypes.html#proptypes
// PeoplePage.propTypes = {};

const perPage = 20;
export default props => (
  <Query
    query={PEOPLE_QUERY}
    variables={{
      offset: 0,
      limit: perPage,
      query: props.query,
    }}
  >
    {({ loading, error, data, fetchMore, refetch }) => (
      <PeoplePage
        {...props}
        loading={loading}
        error={error}
        people={data && data.people}
        search={props.search}
        loadMore={page =>
          fetchMore({
            variables: {
              offset: data.people.length, // perPage * page
            },
            updateQuery: (prev, { fetchMoreResult }) => {
              if (!fetchMoreResult) return prev;
              // console.log({ fetchMoreResult, prev });

              // need to deduplicate otherwise weird shit happens when
              // adding a new person with an existing query
              const people = uniqueBy(
                [...prev.people, ...fetchMoreResult.people],
                person => person.id
              );

              return {
                ...prev,
                people,
              };
              // return {}
              // return Object.assign({}, prev, {
              //   feed: [...prev.feed, ...fetchMoreResult.feed],
              // });
            },
          })
        }
      />
    )}
  </Query>
);



// WEBPACK FOOTER //
// ./src/pages/PeoplePage.js